











































































































import {Vue, Component, Prop} from 'vue-property-decorator';
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import DispositionPicker from "@/view/shared-components/DispositionPicker.vue";
import CustomDatePicker from "@/view/shared-components/CustomDatePicker.vue";
import Disposition from "@/domainObjects/hold/Disposition";

@Component({
    components: {CustomDatePicker, DispositionPicker},
})
export default class HoldDispositionDetails extends Vue {
    @Prop({required: true}) holdTicket!:HoldTicket;
    @Prop({required: true}) type!: String;

    selectDisposition(value) {
        this.holdTicket.disposition = value;
        this.holdTicket.dispositionId = value.id;
    }

    showReverificationRequired():boolean {
        return this.holdTicket.disposition.id === Disposition.REWORK || this.holdTicket.disposition.id === Disposition.SORT;

    }
}
